import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Client } from 'projects/access-control/src/app/Domain/Entities/client.interface';
import { ModuleClient } from 'projects/access-control/src/app/Domain/Entities/module-client.interface';
import { IPkSk } from 'projects/access-control/src/app/Domain/Entities/roles/role.interface';
import { Observable, of } from 'rxjs';
import { environment } from 'projects/access-control/src/environments/environment';
import { ApiService } from '../../Services/api.service';

@Injectable({
	providedIn: 'root',
})
export class ClientService {
	constructor(private api: ApiService, private http: HttpClient) {}

	getAllClient() {
		return this.api.get<any>('/clients/');
	}
	searchClient(search: string) {
		return this.api.get<any>(`/clients/query?_client=${search}`);
	}
	getModuleOneClient(pk: string, sk: string) {
		return this.api.get<any>(`/clients/${pk}/${sk}/modules`);
	}
	getResource(url: string): Observable<any> {
		return this.http.get(url);
	}
	getResourceSearch(url: string, search: string = ''): Observable<any> {
		return this.http.get(url + search);
	}
	deleteModuleOneClient(params: IPkSk, data: ModuleClient): Observable<any> {
		return this.api.patch(`/clients/${params.pk}/${params.sk}/modules/delete`, data);
	}
	createClient(data: object): Observable<any> {
		return this.api.post('/clients/', data);
	}
	updateClient(params: any, data: object): Observable<any> {
		return this.api.patch(`/clients/${params.pk}/${params.sk}`, data);
	}
	createModuleClient(params: IPkSk, data: ModuleClient): Observable<any> {
		return this.api.patch(`/clients/${params.pk}/${params.sk}/modules`, data);
	}

	updateModuleClient(params: IPkSk, data: ModuleClient): Observable<any> {
		return this.api.patch(`/clients/${params.sk}/${params.pk}/modules`, data);
	}
	deleteClient(pk: string, sk: string): Observable<any> {
		return this.api.delete(`/clients/${pk}/${sk}`, {});
	}
}
